import React, { useState } from "react";
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import firebase from "firebase";
import fire from "../helpers/db";
import { NavLink } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";

import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import bglogin from "./bglogin.png"
import googleSvg from "../helpers/search.svg";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	icon: {
		color: "#39ac73",
		width: "100px",
		height: "100px",
		marginBottom: "1rem",
	},
	move: {
		color: "black",
		animation: "scrollTop 0.5s alternate ease infinite",
	},
	moveLogin: {
		color: "white",
		// animation: 'scrollTop 0.5s alternate ease infinite' ,
	},
	iconGoogle: {
		width: "20px",
		height: "20px",
	},
	buttonGoogle: {
		backgroundColor: "#f0f5f5",
		marginTop: "1rem",
	},
}));

const LoginGuru = (props) => {
	const classes = useStyles();
	const [pesanError, setPesanError] = useState("");

	const adminUser = {
		// uid: "b9TIX93xzBbU9oOhudQ6l417bcV2",
		uid: "4LgG4Ek8AlciqSanU7qUoQaHXF03",
		email: "aldirenaldialamin@gmail.com",
	};

	// const handlerLogin = () =>{

	//     console.log(email, password);
	//     fire.auth().signInWithEmailAndPassword(email, password).then(response => {
	//         if (response.user.uid == adminUser.uid){

	//             const {user} = response;
	//             const data = {
	//                 userId: user.uid,
	//                 email: user.email
	//             }
	//             localStorage.setItem('user', JSON.stringify(data));
	//             const storage = localStorage.getItem('user');
	//             const loggedInUser = storage !== null ? JSON.parse(storage) : null;
	//             props.loggedIn(loggedInUser);

	//         }else {

	//             setPesanError("Maaf Anda BUKAN Guru !!!")
	//         }
	//         console.log(email);
	//         console.log(password);
	//         console.log(response);
	//         }).catch((error) => {

	//             const errorMessage = error.message;
	//             console.log(errorMessage);
	//         });
	//     }

	const provider = new firebase.auth.GoogleAuthProvider();

	const SignIn = () => {
		fire
			.auth()
			.signInWithPopup(provider)
			.then((result) => {
				
				if (result.user.uid === adminUser.uid) {
					const token = result.credential.accessToken;
					const user = result.user;
					const data = {
						storetoken: token,
						username: user.displayName,
						email: user.email,
						photo: user.photoURL
					};
					console.log(result)
					localStorage.setItem("user", JSON.stringify(data));
					props.signin(data);
				} else {
					setPesanError("Maaf Anda BUKAN Guru !!!");
				}
			})
			.catch((error) => {
				const errorMessage = error.message;
				// const errorCode = error.code;
				// const email = error.email;
				// const credential = error.credential;
				console.log(errorMessage);
			});
	};
	return (
		<div
			style={{
				backgroundColor: "#c1f7e25e",
			}}
		>
			<div className="row">
				<div className="col">
					<div style={{backgroundColor:'#39ac73', borderRadius:'25px',height:'50px',width:'50px',marginLeft:'25px',marginTop:'1rem'}}>
					<NavLink  to="/">
						{" "}
						<HomeOutlinedIcon  style={{ textDecoration: "none", color:'white', height:'45px',width:'50px', display:'flex', justifyContent:'center' }}/>{" "}
					</NavLink>
					</div>
				</div>
			</div>
			<div>
				<Container className="mt-4">
					<Row>
						<Col lg={4} md={6} sm={12} className="text-center mt-4 p-3">
							<div>
							<AccountCircleOutlinedIcon className={classes.icon} />
							</div>
							{pesanError !== "" ? (
								<div className="alert alert-danger display-7">{pesanError}</div>
							) : (
								""
							)}
							{/* <Form>
								<Form.Group controlId="formBasicEmail" className="mt-2">
									<Form.Control
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										type="email"
										placeholder="Masukkan Email"
									/>
								</Form.Group>

								<Form.Group controlId="formBasicPassword" className="mt-2">
									<Form.Control
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										type="password"
										placeholder="Password"
									/>
								</Form.Group>
								<div className="d-grid gap-2">
									<Button
										type="submit"
										variant="success mt-2"
										size="lg"
										value="LOGIN"
										onClick={() => setPesanError("Kamu Bukan GURU !!!")}
									>
										<div className={classes.moveLogin}>Login</div>
									</Button>
								</div>
							</Form> */}

							<Button
								type="submit"
								className={classes.buttonGoogle}
								size="lg"
								value="LOGIN"
								onClick={() => SignIn()}
							>
								<div className={classes.move}>
									<img
										className={classes.iconGoogle}
										src={googleSvg}
										alt="gambargoogle"
									/>{" "}
									Login with Google
								</div>
							</Button>
						</Col>
						<Col lg={8} md={6} sm={12}>
							<img className="w-100" src={bglogin} alt="svgguru" />
						</Col>
					</Row>
				</Container>
			</div>
		</div>
	);
};

export default LoginGuru;
